import { Link } from "react-router-dom";


const serviceLinks = [
  { label: "Web Design", to: "/services#web-design" },
  { label: "Website Redesign", to: "/services#redesign" },
  { label: "SEO for Small Businesses", to: "/services#seo" },
  { label: "View Pricing", to: "/services#pricing" },
];

const companyLinks = [
  { label: "About Us", to: "/about" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-emerald-950 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand col */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block cursor-pointer mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/7a27f79f-61a9-4968-a678-e038698c6bd9.png"
                alt="PixelCraft Agency logo"
                className="h-10 w-auto brightness-0 invert object-contain"
              />
            </Link>
            <p className="text-emerald-200/70 text-sm leading-relaxed max-w-xs mt-3">
              Affordable, effective small business websites built to get you more customers, more leads, and more visibility on Google.
            </p>
            <div className="flex gap-4 mt-6">
              {[
                { icon: "ri-facebook-fill", href: "#", label: "Facebook" },
                { icon: "ri-instagram-line", href: "#", label: "Instagram" },
                { icon: "ri-linkedin-fill", href: "#", label: "LinkedIn" },
                { icon: "ri-twitter-x-fill", href: "#", label: "Twitter" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-emerald-800/60 hover:bg-accent transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 id="footer-services" className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
              <a href="#footer-services">Services</a>
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-emerald-200/70 hover:text-accent text-sm transition-colors cursor-pointer"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 id="footer-company" className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
              <a href="#footer-company">Company</a>
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-emerald-200/70 hover:text-accent text-sm transition-colors cursor-pointer"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-emerald-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-emerald-200/50 text-xs">
            &copy; {new Date().getFullYear()} PixelCraft Agency. All rights reserved.
          </p>
          <div className="flex gap-5">
            <Link
              to="/privacy"
              className="text-emerald-200/50 hover:text-emerald-200 text-xs transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-emerald-200/50 hover:text-emerald-200 text-xs transition-colors cursor-pointer whitespace-nowrap"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
